import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldTypeKind} from '../enum/field.type.kind';
import {HookKind} from '../enum/hook.kind';

@EntityTable('hook', 'f1134108-187a-4fad-a268-fb4f2b1d6af1')
export class HookEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.TEXT)
    public description: string;

    @Column(FieldTypeKind.STRING)
    public category: string;

    @Column(FieldTypeKind.STRING)
    public language: string;

    @Column(FieldTypeKind.LONG)
    public area: number;

    @Column(FieldTypeKind.ANY)
    public inputs: any[];

    @Column(FieldTypeKind.ANY)
    public outputs: any[];

    @Column(FieldTypeKind.ANY)
    public keywords: string[];

    @Column(FieldTypeKind.ANY)
    public template: any;

    @Column(FieldTypeKind.LONG)
    public kind: HookKind;

    @Column(FieldTypeKind.TEXT)
    public toolTip: string;
}
